export const RoutePaths = {
  SIGNUP: "/signup",
  LOGIN: "/",
  CHATS: "/chats",
  CHAT_DETAIL: "/chats/:documentId",
  CONTACTS: "/contacts",
  SETTINGS: "/settings",
  SETTINGS_ADVANCED: "/settings/advanced",
  SETTINGS_ATTENDINGS: "/settings/attendings",
  SETTINGS_WHATSAPP: "/settings/whatsapp",
  SETTINGS_TAGS: "/settings/tags",
  SETTINGS_BILLING: "/settings/billing",
  SETTINGS_NOTIFICATIONS: "/settings/notifications",
  SETTINGS_DATA_RETENTION: "/settings/data-retention",
  SETTINGS_QUICK_REPLIES: "/settings/quick-replies",
  DASHBOARD: "/dashboard",
  DOCS: "/docs",
  // Documentos legais (single types no Strapi, conteúdo em markdown).
  // Públicas: abrem deslogado — é para cá que o aceite do onboarding aponta.
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms-of-use",
  // Calculadora pública de plano + custo estimado com a Meta. Sem login: é
  // link de marketing/vendas, compartilhável com quem ainda nem tem conta.
  PLAN_CALCULATOR: "/calculadora",
  EMAIL_VERIFIED: "/email-verified",
  EMAIL_CONFIRMATION: "/email-confirmation",
  RESET_PASSWORD: "/reset-password",
  ONBOARDING: "/onboarding",
  FORGOT_PASSWORD: "/forgot-password",
  TEAM_MANAGEMENT: "/team-management",
  // Aba Áreas da Equipe (SA-1367), com gate próprio (`ui:areas:view`).
  TEAM_MANAGEMENT_AREAS: "/team-management/areas",
  ACCEPT_INVITE: "/accept-invite",
  AGENT: "/agent",
  // Playground de agentes: só existe em dev/staging (ver features/playground).
  PLAYGROUND: "/playground",
  FOLLOW_UPS: "/follow-ups",
  ADD_WHATSAPP: "/add-whatsapp",
  PLAN_GATE: "/ativar-plano",
  PREVIEW: "/preview",
  GOOGLE_CALLBACK: "/connect/google/redirect",
  META_SIGNUP_CALLBACK: "/whatsapp/meta/callback",
  INTEGRATIONS: "/integrations",
  INTEGRATIONS_DETAIL: "/integrations/:slug",
  INTEGRATIONS_INSTALL: "/integrations/:slug/install",
  // Redirect URI cadastrado no Google (SA-1359): match exato, por isso o slug
  // vai literal e não como :slug.
  GOOGLE_CALENDAR_CALLBACK: "/integrations/googlecalendar/callback",
  CAMPAIGNS: "/campaigns",
  CAMPAIGN_DETAIL: "/campaigns/:documentId",
  CAMPAIGN_NEW: "/campaigns/new",
  CAMPAIGN_NEW_REVIEW: "/campaigns/new/review",
  CAMPAIGN_EDIT: "/campaigns/:documentId/edit",
  CAMPAIGN_EDIT_REVIEW: "/campaigns/:documentId/edit/review",
  // Disparos automáticos (SA-1319): rotas irmãs de /campaigns, com o segmento
  // estático `automations` ANTES de `/campaigns/:documentId` no AppRoutes.
  AUTOMATIONS: "/campaigns/automations",
  AUTOMATION_NEW: "/campaigns/automations/new",
  AUTOMATION_DETAIL: "/campaigns/automations/:documentId",
  AUTOMATION_EDIT: "/campaigns/automations/:documentId/edit",
} as const;

export const integrationDetailPath = (slug: string) => `/integrations/${slug}`;
export const integrationInstallPath = (slug: string) =>
  `/integrations/${slug}/install`;

export const chatDetailPath = (documentId: string) => `/chats/${documentId}`;

export const campaignDetailPath = (documentId: string) =>
  `/campaigns/${documentId}`;

export const campaignEditPath = (documentId: string) =>
  `/campaigns/${documentId}/edit`;
export const campaignEditReviewPath = (documentId: string) =>
  `/campaigns/${documentId}/edit/review`;

export const automationDetailPath = (documentId: string) =>
  `/campaigns/automations/${documentId}`;
export const automationEditPath = (documentId: string) =>
  `/campaigns/automations/${documentId}/edit`;
